(function (Drupal, once) {
  Drupal.behaviors.unitsMap = {
    attach: function (context) {
      const maps = once("units-map", context.querySelectorAll(".units-map"));
      if (!maps.length) return;

      maps.forEach((mapContainer) => {
        initMap(mapContainer);
      });

      // 🔎 Verificação robusta do Google Maps
      function waitForGoogleMaps(callback, attempts = 40) {
        const mapConstructor = window.google?.maps?.Map;

        if (typeof mapConstructor === "function") {
          callback();
          return;
        }

        if (attempts <= 0) {
          console.warn("Google Maps não carregou corretamente.");
          return;
        }

        setTimeout(() => waitForGoogleMaps(callback, attempts - 1), 250);
      }

      function initMap(mapContainer) {
        let units = [];

        try {
          const rawData = mapContainer.getAttribute("data-units");
          if (rawData) {
            units = JSON.parse(rawData);
          }
        } catch (e) {
          console.error("Erro no parse:", e);
          return;
        }

        if (!Array.isArray(units) || !units.length) return;

        waitForGoogleMaps(() => {
          const firstLat = parseFloat(units[0].lat);
          const firstLng = parseFloat(units[0].lng);

          if (isNaN(firstLat) || isNaN(firstLng)) return;

          const map = new google.maps.Map(mapContainer, {
            center: { lat: firstLat, lng: firstLng },
            zoom: 12,
          });

          const bounds = new google.maps.LatLngBounds();
          const infoWindow = new google.maps.InfoWindow();

          units.forEach((unit) => {
            const lat = parseFloat(unit.lat);
            const lng = parseFloat(unit.lng);

            if (isNaN(lat) || isNaN(lng)) return;

            const position = { lat, lng };

            const marker = new google.maps.Marker({
              position: position,
              map: map,
              title: unit.title || "",
              icon: {
                url: "/themes/custom/hsl_institucional/src/images/map-marker.png",
                scaledSize: new google.maps.Size(36, 48),
                anchor: new google.maps.Point(18, 48),
              },
            });

            marker.addListener("click", () => {
              infoWindow.close();

              const addressParts = [];

              if (unit.street) {
                let line = unit.street;

                if (unit.number) {
                  line += ", " + unit.number;
                }

                if (unit.complement) {
                  line += " - " + unit.complement;
                }

                addressParts.push(line);
              }

              infoWindow.setContent(`
                <div style="min-width:200px">
                  <strong>${unit.title || ""}</strong>
                  ${addressParts.length ? `<div style="margin-top:6px;">${addressParts.join("<br>")}</div>` : ""}
                </div>
              `);

              infoWindow.open(map, marker);
            });

            bounds.extend(position);
          });

          if (units.length > 1) {
            map.fitBounds(bounds);
          }
        });
      }
    },
  };
})(Drupal, once);
